import { openBlock as o, createBlock as r, resolveDynamicComponent as a, withCtx as s, renderSlot as c } from "vue";
import { createActionsContainer as i } from "./design-system.es31.js";
const p = /* @__PURE__ */ Object.assign({
  name: "DsActionsContainer"
}, {
  __name: "ActionsContainer",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  setup(e) {
    const t = i();
    return (n, l) => (o(), r(a(e.as), {
      ref_key: "el",
      ref: t,
      class: "ds-actions-container"
    }, {
      default: s(() => [
        c(n.$slots, "default")
      ]),
      _: 3
    }, 512));
  }
});
export {
  p as default
};
//# sourceMappingURL=design-system.es30.js.map
